import { Activity, ActivityType } from '../types';

interface ParsedActivity {
  type: ActivityType;
  title: string;
  time: string;
  location?: string;
  confirmationNumber?: string;
}

export function parseEmailContent(emailContent: string): ParsedActivity[] {
  const activities: ParsedActivity[] = [];
  
  const flightRegex = /Flight\s*:\s*([A-Z]{2}\s*\d+)|Confirmation\s*:\s*([A-Z0-9]+)/gi;
  const hotelRegex = /Hotel\s*:\s*(.*?)(?:\n|$)|Check-in\s*:\s*(.*?)(?:\n|$)/gi;
  const timeRegex = /\b(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm))\b/g;
  
  const lines = emailContent.split('\n');
  
  lines.forEach((line) => {
    if (flightRegex.test(line)) {
      const matches = line.match(flightRegex);
      if (matches) {
        activities.push({
          type: 'flight',
          title: `Flight ${matches[0]}`,
          time: extractTime(line) || '12:00 PM',
          confirmationNumber: extractConfirmation(line),
        });
      }
    }
    
    if (hotelRegex.test(line)) {
      const hotelName = line.match(/Hotel\s*:\s*(.*?)(?:\n|$)/i)?.[1];
      if (hotelName) {
        activities.push({
          type: 'hotel',
          title: hotelName.trim(),
          time: extractTime(line) || '3:00 PM',
          location: extractLocation(line),
        });
      }
    }
  });
  
  return activities;
}

function extractTime(text: string): string | undefined {
  const match = text.match(/\b(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm))\b/);
  return match ? match[1] : undefined;
}

function extractConfirmation(text: string): string | undefined {
  const match = text.match(/Confirmation\s*:\s*([A-Z0-9]+)/i);
  return match ? match[1] : undefined;
}

function extractLocation(text: string): string | undefined {
  const match = text.match(/(?:at|in|location:)\s*(.*?)(?:\n|,|$)/i);
  return match ? match[1].trim() : undefined;
}